import React from 'react'
import { useQuery } from '@apollo/client'
import Dialog from 'components/dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import Button from '@material-ui/core/Button'
import LaunchOutlinedIcon from 'components/material-symbol/icons/Launch'
import { PAYMENT_ACCOUNT_LINK_SETUP } from './queries'
import { amplitudeEvent } from 'lib/amplitude'
import { useDialogTitleStyles } from 'components/dialog/use-dialog-title-styles'

const ManageStripeAccountConfirmationDialog = ({
  paymentAccount,
  isOpen,
  onClose,
}) => {
  const classes = useDialogTitleStyles()
  const { detailsSubmitted, id } = paymentAccount || {}
  const { data, loading, error } = useQuery(PAYMENT_ACCOUNT_LINK_SETUP, {
    variables: {
      accountId: id,
      returnUrl: window.location.href,
    },
    skip: detailsSubmitted || !isOpen,
  })

  const accountLink = data?.paymentAccountLinkSetup?.accountLink

  return (
    <Dialog
      isOpen={isOpen}
      maxWidth="xs"
      fullWidth
      onClose={onClose}
      showCloseButton
      classes={{ paper: classes.dialogPaper }}
    >
      {({ closeDialog }) => {
        const launchStripe = () => {
          if (!detailsSubmitted) {
            amplitudeEvent('resumed-payment-account-onboarding', {
              payment_account_name: paymentAccount.name,
              source: 'Coach',
              url: window.location.href,
              path: window.location.pathname,
            })
            window.open(accountLink)
          } else {
            amplitudeEvent('managed-payment-account', {
              payment_account_name: paymentAccount.name,
              source: 'Coach',
              url: window.location.href,
              path: window.location.pathname,
            })
            window.open(paymentAccount.manageUrl)
          }
          closeDialog()
        }

        return (
          <>
            <DialogTitle
              disableTypography
              classes={{ root: classes.titleRoot }}
            >
              <Typography component="h2" className={classes.title}>
                Manage Stripe account
              </Typography>
              {!loading && !error && (
                <Typography className={classes.bodyText}>
                  Making any changes will affect each of the connections you
                  have to this Stripe account.
                </Typography>
              )}
            </DialogTitle>
            {loading && <LinearProgress />}
            {error && (
              <div className={classes.content}>
                <Typography color="error">Error loading data</Typography>
              </div>
            )}
            {!loading && !error && (
              <DialogActions className={classes.actions}>
                <Button color="primary" onClick={closeDialog}>
                  Cancel
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  disabled={!detailsSubmitted && !accountLink}
                  onClick={launchStripe}
                  endIcon={<LaunchOutlinedIcon fontSize="small" />}
                >
                  Manage Stripe
                </Button>
              </DialogActions>
            )}
            {error && (
              <DialogActions className={classes.actions}>
                <Button color="primary" onClick={closeDialog}>
                  Cancel
                </Button>
              </DialogActions>
            )}
          </>
        )
      }}
    </Dialog>
  )
}

export default ManageStripeAccountConfirmationDialog
